import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { t } from '../../../../../../modules/infra/i18n';

import CancelButton from './CancelButton';
import SaveButton from './SaveButton';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../../../modules/infra/feature-flags';

const AddControls = props => (
  <div>
    <div className="c-separator u-mv" />
    <div className="o-flexbox u-mh u-pb">
      <div className="o-flexbox__item">
        <CancelButton {...props} />
      </div>
      <div className="o-flexbox__item">
        <button
          type="button"
          className="c-btn c-btn--outline c-btn--outline-grey u-width-125 u-mr"
          onClick={props.previousTab}
          display-if={props.activeTab > 0}
        >
          &#8592; {t('barber:add_controls.previous_button')}
        </button>
        <button
          type="submit"
          className="c-btn c-btn--outline c-btn--outline-grey u-width-125"
          display-if={props.activeTab < props.createBarberTabIndex}
        >
          {t('barber:add_controls.next_button')} &#8594;
        </button>
        <SaveButton
          {...props}
          text={props.activeTab === props.lastTabIndex ? t('barber:add_controls.save_button') : `${t('barber:add_controls.save_and_continue_button')} →`}
          display-if={props.activeTab >= props.createBarberTabIndex}
        />
      </div>
    </div>
  </div>
);

AddControls.propTypes = {
  activeTab: PropTypes.number.isRequired,
  lastTabIndex: PropTypes.number.isRequired,
  createBarberTabIndex: PropTypes.number.isRequired,
  previousTab: PropTypes.func.isRequired,
};

export default compose(
  withInjectFeatureFlagsToProps([flagNames.HYBRID_STAFF_PAYMENTS_TAB]),
  withProps((props) => ({
    // barber is created at tab index 2 when payments tab is shown before locations tab
    createBarberTabIndex: props[flagNames.HYBRID_STAFF_PAYMENTS_TAB] ? 2 : 1,
  }))
)(AddControls);
